import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard__header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Member Details", -1)
const _hoisted_3 = { class: "button--inverted" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Manage Member ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", { class: "dropdown-button__option" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "dropdown-button__option-button--danger" }, " Transfer Ownership ")
], -1)
const _hoisted_6 = { class: "player__info" }
const _hoisted_7 = { class: "breadcrumbs overflow-container" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Members ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__slash" }, " / ", -1)
const _hoisted_10 = { class: "breadcrumbs__item" }
const _hoisted_11 = { class: "player__created-date" }
const _hoisted_12 = { class: "dashboard__section" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, " Permissions ", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Are you sure you want to kick ")
const _hoisted_15 = { class: "high-em" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("? You can invite them again. ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Kick ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_dropdown_button = _resolveComponent("dropdown-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_permissions_switches = _resolveComponent("permissions-switches")!
  const _component_save_popup = _resolveComponent("save-popup")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_dropdown_button, { class: "no-margin-top" }, {
          button: _withCtx(() => [
            _createElementVNode("button", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_fa_icon, { icon: ['fas', 'cog'] })
            ])
          ]),
          options: _withCtx(() => [
            _createElementVNode("li", {
              class: "dropdown-button__option",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeleteModal = true))
            }, [
              _createElementVNode("button", {
                class: "dropdown-button__option-button--danger",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeleteModal = true))
              }, " Kick Member ")
            ]),
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            class: "breadcrumbs__item",
            to: `/dashboard/${_ctx.$route.params.subdomain}/members`
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["to"]),
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.member?.fullName) + " (" + _toDisplayString(_ctx.member?.email) + ") ", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_fa_icon, { icon: ['far', 'clock'] }),
          _createTextVNode(" Joined " + _toDisplayString(_ctx.formattedDate), 1)
        ])
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          (_ctx.member)
            ? (_openBlock(), _createBlock(_component_permissions_switches, {
                key: 0,
                modelValue: _ctx.member.permissions,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.member.permissions) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_save_popup, {
          loading: _ctx.loading,
          show: _ctx.memberChanged
        }, null, 8, ["loading", "show"])
      ], 32)
    ]),
    _withDirectives(_createVNode(_component_modal, {
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDeleteModal = false))
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Kick " + _toDisplayString(_ctx.member?.fullName), 1)
      ]),
      message: _withCtx(() => [
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.member?.fullName), 1),
        _hoisted_16
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_loading_button, {
          "button-type": "button--danger",
          loading: _ctx.kickLoading,
          onClick: _ctx.kickMember
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createElementVNode("button", {
          class: "button--no-bg danger no-margin-top",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDeleteModal = false))
        }, " Cancel ")
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.showDeleteModal]
    ])
  ], 64))
}